import React, { Component, ErrorInfo, ReactNode } from "react";
import { connect } from "react-redux";
import { sendErrorNotification } from "../../Redux/appSlice";

interface Props {
    children?: ReactNode;
    sendErrorNotification: any;
    currentModuleName: string;
}

interface State {
    hasError: boolean;
    error: Error;
}

class ModuleErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: {} as Error
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error: error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.props.sendErrorNotification({
            receiver_email_address: "support@hyprock.com", custom: {
                module_name: this.props.currentModuleName,
                error_description: `Name: ${error.name}, Cause: ${error.cause}, stack: ${error.stack}`,
                error_code: "500"
            }
        });
    }

    public render() {
        if (this.state.hasError) {
            return <><h1>We have a problem loading the module. Notification has been sent to the administration.</h1>
                <pre>
                    {this.state.error.name}
                    {this.state.error.cause}
                    {this.state.error.stack}
                </pre>
            </>;
        }

        return this.props.children;
    }
}

const mapStateToProps = (state: any) => {
    return { currentModuleName: state?.app?.module?.module_name };
};

const mapDispatchToProps = { sendErrorNotification };

export default connect(mapStateToProps, mapDispatchToProps)(ModuleErrorBoundary);
